import { v4 as uuidv4 } from 'uuid';

function get(filedName) {
    return filedName.replace(/[^\w\s!?]/g, '') + "__" + uuidv4();
}

export default get